// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"71f4cde1","315":"dd513ac8","567":"ebc88223"}[chunkId] + ".chunk.js";
};